/** @jsx jsx */
import React from "react"
import { jsx } from "theme-ui"
import { graphql } from "gatsby"
import Layout from "@components/Layouts"
import Section from "@components/Section"
import Container from "@components/Container"
import Link from "@components/Link"
import TwoColumnSection, {
  Block as ColumnBlock,
  ImageBlock as ColumnImageBlock,
} from "@components/TwoColumnSection"
import CTAHeadingBlock from "@components/CTAHeadingBlock"
import SEO from "@components/seo"
import joinUsHeader from "@static/images/join-us/joinUsHeader.jpg"
import BannerBlock from "@components/BannerBlock"
import { rem } from "@src/theme"

const PageJoinUs = ({ data, ...props }) => {
  return (
    <>
      <SEO
        title="Join the Team"
        image={joinUsHeader}
        description={data.og.frontmatter.ogdescription}
        pathname={props.location.pathname}
      />
      <div
        sx={{
          bg: "pink",
        }}
      >
        <TwoColumnSection
          col1={
            <ColumnBlock
              styles={{
                bg: "purple",
                color: "pink",
              }}
            >
              <CTAHeadingBlock
                heading="Join the team!"
                body="By joining the team at Minus, everything you do will help empower LGBTQIA+ youth to feel confident and have fun. You’ll make a massive impact on thousands of lives."
              />
            </ColumnBlock>
          }
          col2={<ColumnImageBlock image={joinUsHeader} />}
        />

        <Section>
          <Container>
            <BannerBlock title="Careers at Minus18">
              <div>
                <p
                  sx={{
                    mt: 0,
                    textAlign: "center",
                  }}
                >
                  Join the Minus18 team and make an impact on your community!
                  Check out all our current job opportunities below.
                </p>

                <div
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: rem(40),
                  }}
                >
                  <Link to="https://jobs.swagapp.com/jobs/organisations/8b0de3a6-f05d-420a-a577-008d264bd39b">
                    Job opportunities
                  </Link>
                </div>
              </div>
            </BannerBlock>
          </Container>
        </Section>
      </div>
    </>
  )
}

export default PageJoinUs

export const pageQuery = graphql`
  query {
    og: markdownRemark(
      fileAbsolutePath: { glob: "**/pages/join-us/index.md" }
    ) {
      frontmatter {
        ogdescription
      }
    }
  }
`
